import type { ArchiveSearchParams, PartialArchiveSearchParams } from "@/types";
import getCurrentYearAndMonth from "./getCurrentYearAndMonth";

const parsePositiveInt = (value: string | null | undefined) => {
  if (!value) {
    return undefined;
  }

  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return undefined;
  }

  return parsed;
};

const getResolvedArchiveSearchParams = (
  params: PartialArchiveSearchParams,
): ArchiveSearchParams => {
  const { currentYear, currentMonth } = getCurrentYearAndMonth();
  const defaultMonth = currentMonth + 1;

  const year = parsePositiveInt(params.year) ?? currentYear;
  const month = parsePositiveInt(params.month) ?? defaultMonth;
  const pageNumber = parsePositiveInt(params.pageNumber) ?? 1;

  const resolvedMonth = month >= 1 && month <= 12 ? month : defaultMonth;

  return {
    year: String(year),
    month: String(resolvedMonth),
    pageNumber: String(pageNumber),
  };
};

export default getResolvedArchiveSearchParams;
